<template>
    <div>
        <div v-if="authUserPermission['drawing-master-view']">
            <base-header class="pb-6">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-7">
                        <h6 class="h2 text-white d-inline-block mb-0"></h6>
                    </div>      
                </div>
            </base-header>
            <div class="container-fluid mt--6">
                <div class="card mb-4">
                    <div class="card-header mt--4 mb--4">
                        <div class="row">
                            <div class="col">
                                <h3 class="mb-0">{{ tt('drawing_master') }}</h3>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <input type="text" class="form-control form-control-sm text-center border-radius-20" v-model="table.search" :placeholder="tt('search_drawing_master')" v-on:keyup="filter"/>                
                                </div>
                            </div>
                            <div class="col text-right">
                                <base-button size="sm" type="default" @click="create" v-if="authUserPermission['drawing-master-create']">{{ tt('add_new') }}</base-button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <el-table height="350px" class="table-responsive table-flush" header-row-class-name="thead-light" :data="table.data" v-if="!onLoad">
                            <el-table-column :label="tt('company_code')" :prop="tt('company_code')" min-width="180px" sortable>
                                <template v-slot="{row}">
                                    {{row.company_code}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('equipment_code')" :prop="tt('equipment_code')" min-width="180px" sortable>
                                <template v-slot="{row}">
                                    {{row.equipment_code}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('drawing_number')" :prop="tt('drawing_number')" min-width="185px" sortable>
                                <template v-slot="{row}">
                                    {{row.drawing_number}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('drawing_name')" :prop="tt('drawing_name')" min-width="180px" sortable>
                                <template v-slot="{row}">
                                    {{row.drawing_name}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('created_by')" :prop="tt('created_by')" min-width="145px" sortable>
                                <template v-slot="{row}">
                                    {{row.created_by}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('date')" :prop="tt('date')" min-width="140px" sortable>
                                <template v-slot="{row}">
                                    {{row.created_at}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('attachment')" :prop="tt('attachment')" min-width="170px" sortable>
                                <template v-slot="{row}">
                                    <a :href="apiUrl+'drawing_master/'+row.file_name" target="_blank">{{row.file_name}}</a>
                                </template>
                            </el-table-column>
                            <el-table-column prop="action" width="100">
                                <template v-slot="{row}">
                                    <el-dropdown trigger="click" class="dropdown" @command="handleTableAction" :hide-on-click="true" v-if="authUserPermission['drawing-master-update'] || authUserPermission['drawing-master-delete']">
                                        <span class="btn btn-sm btn-icon-only text-light">
                                            <i class="fas fa-ellipsis-v mt-2"></i>
                                        </span>
                                        <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                                            <el-dropdown-item :command="{action:'edit', data:row.id}" v-if="authUserPermission['drawing-master-update']">Edit</el-dropdown-item>
                                            <el-dropdown-item :command="{action:'remove', data:row.id}" v-if="authUserPermission['drawing-master-delete']">Delete</el-dropdown-item>                                        
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                        <page-loading v-else/>
                    </div>  
                    <div class="card-footer pb-0 ">   
                        <span class="float-left">
                            <base-pagination :page-count="table.page.last_page" v-model="table.page.current_page" @click.native="changePage(table.page.current_page)" size="sm"></base-pagination>
                        </span>                             
                        <span class="float-right">
                            {{ tt('page_info', {size: (table.page.current_page - 1) * table.page.per_page + table.data.length, total: table.total}) }}
                        </span>
                    </div>
                </div>
            </div>
            <validation-observer v-slot="{invalid}">
                <modal :show.sync="form.show">
                    <template slot="header">
                        <h5 class="modal-title">{{form.title}}</h5>
                    </template>
                    <div>
                        <base-alert type="danger" v-if="errorMessage">
                            <p><strong>{{ errorMessage.message }}</strong></p>
                            <div v-if="errorMessage.data.length != 0">
                                <span v-for="message in errorMessage.data">
                                    {{ message[0] }}<br>
                                </span>
                            </div>
                        </base-alert>

                        <label class="form-control-label">{{ tt('company_code') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('menu')" rules="required">
                            <el-select class="select-danger" v-model="drawingMaster.company_code" :placeholder="tt('choose_company')">
                                <el-option class="select-danger" :value="mm['company_code']" :label="mm['menu']" :key="mm['menu']" v-for="mm in  companyCode"></el-option>
                            </el-select>
                        </base-input>

                        <label class="form-control-label">{{ tt('equipment_code') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('menu')" rules="required">
                            <el-select class="select-danger" v-model="drawingMaster.equipment_code" :placeholder="tt('choose_equipment')">
                                <el-option class="select-danger" :value="mm['equipment_code']" :label="mm['menu']" :key="mm['menu']" v-for="mm in  equipmentCode"></el-option>
                            </el-select>
                        </base-input>

                        <label class="form-control-label">{{ tt('drawing_number') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('name')" :placeholder="tt('drawing_number')" v-model="drawingMaster.drawing_number" rules="required|max:50"></base-input>

                        <label class="form-control-label">{{ tt('drawing_name') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('name')" :placeholder="tt('drawing_name')" v-model="drawingMaster.drawing_name" rules="required|max:50"></base-input>

                        <label class="form-control-label">{{ tt('attachment') }} <span class="text-danger">*</span></label>
                        <file-input rules="required" @change="filesChange" ref="file_name" accept="application/pdf"></file-input>

                    </div>
                    <template slot="footer">
                        <base-button type="secondary" @click="form.show = false">{{ tt('close') }}</base-button>
                        <base-button type="primary" v-on:click="save" :disabled="btnSave.onLoading || invalid">
                            <span v-if="btnSave.onLoading"><i class="fas fa-spinner fa-spin"></i> {{ tt('please_wait') }}</span>
                            <span v-else>
                                <span v-if="form.add">{{ tt('add') }}</span>
                                <span v-else>{{ tt('edit') }}</span>
                            </span>
                        </base-button>
                    </template>
                </modal>
            </validation-observer>
        </div>
        <noaccess v-else/>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import Api from '@/helpers/api';
    import drawingMaster from '@/services/dictionary/drawingMaster.service';
    import companyCode from '@/services/master/companyCode.service';
    import equipmentCode from '@/services/master/equipmentCode.service';
    import baseApiUrl from '@/configs/config';

    export default {        
        data() {
            return {      
                onLoad: true,      
                loadTimeout: null,  
                btnSave: {
                    onLoading: false
                },                    
                form: {
                    add: true,
                    title: "Create New Sub Menu",
                    show: false
                }, 
                table: {
                    search: '',                    
                    total: 0,
                    data: [],
                    page: {
                        current_page: 1,
                        per_page: 100,
                    },
                },     
                errorMessage: null,  
                links: [], 
                companyCode: {},
                drawingMaster: {},
                equipmentCode: {},
                apiUrl: baseApiUrl.storageUrl,
            }
        },
        computed: {
            ...mapState({
                authUserPermission :state => state.auth.userPermission
            }),
        },
        mounted() {
            this.get()
            this.getcompanyCode()
            this.getequipmentCode()
        },
        methods: {
            get() { 
                let context = this;               
                Api(context, drawingMaster.get(this.table.page.current_page, {search: this.table.search})).onSuccess(function(response) {    
                    context.table.total = response.data.data.data.total;
                    context.table.data = response.data.data.data.data; 
                    context.table.page  = response.data.data.data; 
                    context.onLoad = false;         
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.table.data = [];
                        context.table.total = 0;
                        context.onLoad = false;
                    }
                })
                .call()
            },
            getcompanyCode() {
                let context = this;               
                Api(context, companyCode.get({})).onSuccess(function(response) {
                    context.companyCode = response.data.data.data.data;
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.companyCode = [];
                    }
                })
                .call()
            },
            getequipmentCode() {
                let context = this;               
                Api(context, equipmentCode.get({})).onSuccess(function(response) {    
                    context.equipmentCode = response.data.data.data.data;
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.equipmentCode = [];
                    }
                })
                .call()
            },
            filter() {
                this.onLoad = true;
                this.table.page.current_page = 1;
                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()
                }, 100);
            },
            handleTableAction(command) {
                switch (command.action) {
                    case 'edit':
                            this.edit(command.data);
                        break;
                    case 'remove':
                            this.remove(command.data);
                        break;
                    default:
                        break;
                }
            },
            create() {
                this.errorMessage = null;
                this.form.add = true;
                this.form.title = this.tt('add_new_drawing_master');
                this.form.show = true;
                this.drawingMaster = {};
            },            
            edit(id) {
                this.errorMessage = null;
                let context = this;               
                Api(context, drawingMaster.show(id)).onSuccess(function(response) {
                    context.drawingMaster = response.data.data;
                    context.form.add = false;
                    context.form.title = context.tt('update_sub_menu');
                    context.form.show = true;                          
                })
                .call()        
            },
            filesChange(files) {
                this.drawingMaster.file_name = files[0];
            },
            save() {                      
                this.btnSave.onLoading = true;
                let api = null;
                let context = this;
                let formData = new FormData(); 

                formData.append('company_code', this.drawingMaster.company_code);
                formData.append('equipment_code', this.drawingMaster.equipment_code);
                formData.append('drawing_number', this.drawingMaster.drawing_number);
                formData.append('drawing_name', this.drawingMaster.drawing_name);
                if (this.drawingMaster.file_name == undefined) {
                    formData.append('file_name', '');
                }else{
                    formData.append('file_name', this.drawingMaster.file_name);
                }
                
                if (this.form.add) {
                    api = Api(context, drawingMaster.create(formData));
                } else {{
                    api = Api(context, drawingMaster.update(this.drawingMaster.id, formData));
                }}
                api.onSuccess(function(response) {
                    context.get();
                    context.$notify({
                        message: response.data.message,                  
                        type: 'success'
                    });
                    context.form.show = false;
                }).onError(function(error) {                    
                    context.errorMessage = error.response.data;
                }).onFinish(function() {
                    context.btnSave.onLoading = false;   
                })
                .call();
            },
            remove(id) {
                this.confirmDialog(this.tt('confirm_delete')).then((result) => {
                    let context = this;
                    if (result.value) {
                        Api(context, drawingMaster.delete(id)).onSuccess(function(response) {
                            context.$notify({
                                message: response.data.message,
                                type: 'success'
                            });
                            context.get();
                        }).call();
                    }
                })
            },
            changePage(page) {
                let context = this;
                context.onLoad = true;

                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()
                }, 100);
            },
        }   
    };
</script>
<style></style>
